
import React from 'react';
import {
  Icon, Button, Radio, Select
} from 'antd';
import styled from 'react-emotion';
import {
  width, height, space, color, bottom, themeGet,
} from 'styled-system';
import LoadSpinnerOverlay from '../LoadSpinner';

export const Label = styled('span')`
  ${space}
  font-weight: bold;
  text-transform: capitalize;
`;

export const DataTypeDropdown = styled(Select)` &&& {
  margin-right: 15px;
  ${space}
  ${color}
  ${width}
}`;

export const Loading = styled(LoadSpinnerOverlay)` &&& {
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: white;
}`;

export const NestedLink = styled('a')`
  ${color}

  &:hover {
    ${color}
  }
`;

export const InfoIcon = styled(props => (
  <Icon type="question-circle" {...props} />
))`
  cursor: pointer;
`;

export const InfoToolTipList = styled('ul')`
  padding-left: 0;
  font-size: .8em;
`;

export const ScrollableVHContainer = styled('div')`
  height: calc(100vh - 300px - ${themeGet('heights.navBarHeight')});
  width: 100%;
  box-sizing: border-box;
  overflow: scroll;
`;

export const ShowAllButton = styled(Button)` &&& {
  ${color}
  ${space}
  ${bottom}
  position: fixed;
  right: 0;
  border-radius: 0;
  border: 0px;
  width: 100%;

  &:hover {
    opacity: .75;
  }

  -ms-transition: bottom .5s;
  transition: bottom .5s;
}`;

export const ModalContentWrapper = styled('div')`
  ${width}
  ${height}
`;

export const InOutSelect = styled(Radio.Group)` &&& {
  position: absolute;
  margin-top: -86px;
  right: 30px;
}`;

export const ComparisonDrawerTitleContainer = styled('div')`
  display: flex;
  align-items: center;
  > div:first-child {
    display: inline-block;
    margin-right: auto;
    > * { 
      display: block;
      margin: 0.25em 0;
    }
  }
`;

export const KpiReportContainer = styled('section')`
  overflow: auto;
`;

export const KpiReport = styled('div')`
  padding: 1.25em;
  zoom: 0.75;
  display: inline-flex;
  flex-direction: column;
  
  .ant-table-thead {
    background: #f3f3f3;
  }
`;
